import { Button, Grid, MenuItem } from "@material-ui/core";
import React, { MouseEvent, ChangeEventHandler } from "react";
import {useSelector} from "react-redux";

import CustomTextField from "../../../../components/inputs/CustomTextField";
import {getUserType} from "../../../../modules/auth";

interface StatusOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface Props {
  status: string;
  statuses: StatusOption[];
  handleSetStatus: (event: MouseEvent) => void;
  handleStatusChange: ChangeEventHandler<HTMLInputElement>;
  styleDropDownContainer?: {};
  styleBottomContainer?: {};
}

const SetStatus = ({
  status,
  statuses,
  handleSetStatus,
  handleStatusChange,
  styleDropDownContainer,
  styleBottomContainer,
}: Props): JSX.Element => {
  const type = useSelector(getUserType);
  const [isUpdating, setIsUpdating] = React.useState(false);
  return (
    <Grid
      container
      justify="flex-end"
      alignItems="center"
      spacing={32}
      style={{ paddingRight: "32px" }}
    >
      <Grid item xs={2}
        style={styleDropDownContainer}
      >
        <CustomTextField
          fullWidth
          select
          name="status"
          label="Status"
          value={status}
          onChange={handleStatusChange}
        >
          {statuses.filter(status => {
            if (status.value === "non_factored") {
              return false;
            }
            if (type === "factoring_remote_admin") {
              if (
                status.value === "special_pending" ||
                status.value === "pending_originals" ||
                status.value === "pending_delivery" ||
                status.value === "approved" ||
                status.value === "remote_approved" ||
                status.value === "declined" ||
                status.value === "paid" ||
                status.value === "cloneops_pending"
              ) {
                return false;
              }
            }
            return true;
          }).map(
            ({ value, label, disabled }): JSX.Element => (
              <MenuItem value={value} disabled={disabled}>{label}</MenuItem>
            )
          )}
        </CustomTextField>
      </Grid>
      <div style={{ padding: 20, ...styleBottomContainer }}>
        <Button
          variant="contained"
          color="primary"
          mini
          onClick={async (event) => {
            setIsUpdating(true);
            await handleSetStatus(event);
            setIsUpdating(false);
          }}
          disabled={isUpdating}
        >
          Set Status
        </Button>
      </div>
    </Grid>
  );
}

export default SetStatus;
